document.addEventListener('DOMContentLoaded', function () {
  const targets = document.querySelectorAll('h1');

  targets.forEach(el => el.classList.add('slide-in-left'));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  targets.forEach(el => observer.observe(el));
});



